import GoToPayment from './GoToPayment';

export default GoToPayment;
